<template>
    <div v-loading="loading">
        <apply-header :flag="'1'"></apply-header>
        <div class="main" :style="{'min-height':(getHeight-80)+'px'}">
            <Side :step="'2'"></Side>
            <section>

            <div class="info-form" v-if="!showResult&&hasFinished">
                <div class="box">
                    <h1 class="serviceTestTitle">eAssist Orthodontic Billing Assessment Test</h1>
                    <p style="margin: 10px 0">Instructions:</p>
                    <div style="line-height: 25px">Please read each question carefully. Choose the correct answer to each question. You must
                        score at least an <span>{{passPercent}}</span> for it to be considered a passing score.
                    </div>
                    <p class="required" style="margin: 10px 0">* Required</p>
                </div>

                <el-form :model="form" :inline="false" :rules="rules" ref="form">
                    <div class="box">
                        <div>Your most proficient orthodontic software<span class="required">*</span></div>
                        <el-form-item label="Your answer" style="margin-top: 20px" prop="software" ref="software">
                            <el-input type="text" style="width: 80%" v-model="form.software" :disabled="isAdmin"></el-input>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub0!=2" :src="wrong"></el-image>
                            1) Define the Primary Dentition<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub0" style="margin-top: 20px">
                            <el-radio-group ref="sub0" style="width: 100%" v-model="form.sub0" :disabled="isAdmin">
                                <el-radio :label="0"><div class="radioText">The final phase of the transition from primary to adult teeth, in which the<br v-if="smallScreen"> deciduous
                                    molars and canines are <br v-if="!smallScreen">in the process of shedding and the<br v-if="smallScreen"> permanent successors are
                                    emerging.</div>
                                </el-radio><br>
                                <el-radio :class="[smallScreen?'mt30':'mt10']" :label="1"><div class="radioText">The dentition that is present after the cessation of growth that would affect<br v-if="smallScreen">
                                    orthodontic treatment.</div>
                                </el-radio><br>
                                <el-radio :class="[smallScreen?'mt10':'']" :label="2">Teeth developed and erupted first in order of time.</el-radio>
                                <el-image v-if="isAdmin&&form.sub0==2" class="rightPic" :src="right"></el-image>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub1!=1" :src="wrong"></el-image>
                            2) Define the Transitional Dentition<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub1" style="margin-top: 20px">
                            <el-radio-group ref="sub1" style="width: 100%" v-model="form.sub1" :disabled="isAdmin">
                                <el-radio :label="0">Teeth developed and erupted first in order of time.
                                </el-radio><br>
                                <el-radio :label="1"><div class="radioText">The final phase of the transition from primary to adult teeth, in which the deciduous<br v-if="smallScreen">
                                    molars and canines are in the process <br v-if="!smallScreen">  of shedding and the permanent successors<br v-if="smallScreen">are shedding.</div>
                                </el-radio><el-image v-if="isAdmin&&form.sub1==1" class="rightPic" :src="right"></el-image><br>
                                <el-radio :class="[smallScreen?'mt30':'mt10']" :label="2"><div class="radioText">The dentition that is present after the normal loss of primary teeth and prior to<br v-if="smallScreen">
                                    cessation of growth that would affect orthodontic treatment.</div></el-radio><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub2!=0" :src="wrong"></el-image>
                            3)  Define the ADolescent Dentition<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub2" style="margin-top: 20px">
                            <el-radio-group ref="sub2" style="width: 100%" v-model="form.sub2" :disabled="isAdmin">
                                <el-radio :label="0"><div class="radioText">The dentition that is present after the normal loss of primary teeth and prior to
                                    <br v-if="smallScreen">cessation of growth that would affect orthodontic treatment.</div>
                                </el-radio><el-image v-if="isAdmin&&form.sub2==0" class="rightPic" :src="right"></el-image><br>
                                <el-radio :class="[smallScreen?'mt10':'']" :label="1"><div class="radioText">The dentition that is present after the cessation of growth that would affect
                                    <br v-if="smallScreen">orthodontic treatment.</div>
                                </el-radio><br>
                                <el-radio :class="[smallScreen?'mt10':'']" :label="2"><div class="radioText">The final phase of the transition from primary to adult teeth, in which the deciduous
                                    <br v-if="smallScreen">molars are in the process of shedding and the <br v-if="!smallScreen">permanent successors are emerging.</div></el-radio><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub3!=3" :src="wrong"></el-image>
                            4) What would the procedure code D8220 be used for?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub3" style="margin-top: 20px">
                            <el-radio-group ref="sub3" style="width: 100%" v-model="form.sub3" :disabled="isAdmin">
                                <el-radio :label="0">Orthodontic Retention</el-radio><br>
                                <el-radio :label="1">Space Maintainer-Fixed-Bilateral</el-radio><br>
                                <el-radio :label="2">Removable Appliance Therapy</el-radio><br>
                                <el-radio :label="3">Fixed Appliance Therapy</el-radio>
                                <el-image v-if="isAdmin&&form.sub3==3" class="rightPic" :src="right"></el-image><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub4!=1" :src="wrong"></el-image>
                            5) True or False: Dental insurance always includes orthodontic coverage.<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub4" style="margin-top: 20px">
                            <el-radio-group ref="sub4" style="width: 100%" v-model="form.sub4" :disabled="isAdmin">
                                <el-radio :label="0">True</el-radio><br>
                                <el-radio :label="1">False</el-radio><el-image v-if="isAdmin&&form.sub4==1" class="rightPic" :src="right"></el-image><br>
                            </el-radio-group>
                        </el-form-item>
                    </div> <div class="box">
                    <div class="subjectTest"><el-image v-if="isAdmin&&form.sub5!=1" :src="wrong"></el-image>
                        6) An underbite is a typical characteristic of a
                        ______malocclusion.<span class="required">*</span></div>
                    <div class="score" >2 points</div>
                    <el-form-item prop="sub5" class="mt20">
                        <el-radio-group ref="sub5" style="width: 100%" v-model="form.sub5" :disabled="isAdmin">
                            <el-radio :label="0">Class II</el-radio><br>
                            <el-radio :label="1">Class III</el-radio><el-image v-if="isAdmin&&form.sub5==1" class="rightPic" :src="right"></el-image><br>
                            <el-radio :label="2">Class I</el-radio><br>
                            <el-radio :label="3">Class IV</el-radio><br>
                        </el-radio-group>
                    </el-form-item>
                </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub6!=1" :src="wrong"></el-image>
                            7) What is the “Banding Date”?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub6" class="mt20">
                            <el-radio-group ref="sub6" v-model="form.sub6" :disabled="isAdmin">
                                <el-radio :label="0">The date impressions were taken for orthodontic records</el-radio><br>
                                <el-radio :label="1">The date the orthodontic appliance was placed/delivered.</el-radio>
                                <el-image v-if="isAdmin&&form.sub6==1" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="2">The date the patient had elastics placed and instructions were given</el-radio><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub7!=1" :src="wrong"></el-image>
                            8) If an orthodontic practice accepts assignment of benefits, the
                            insurance company reimburses the ____________.<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub7" class="mt20">
                            <el-radio-group ref="sub7" style="width: 100%" v-model="form.sub7" :disabled="isAdmin">
                                <el-radio :label="0">patient</el-radio><br>
                                <el-radio :label="1">practice</el-radio><el-image v-if="isAdmin&&form.sub7==1" class="rightPic" :src="right"></el-image><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub8!=0" :src="wrong"></el-image>
                            9) A preauth and supportive documentation is required for medically
                            necessary treatment.<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub8" class="mt20">
                            <el-radio-group ref="sub8" style="width: 100%" v-model="form.sub8" :disabled="isAdmin">
                                <el-radio :label="0">True</el-radio><el-image v-if="isAdmin&&form.sub8==0" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="1">False</el-radio><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub9!=3" :src="wrong"></el-image>
                            10) Which procedure code represents Comprehensive Orthodontic
                            Treatment?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub9" class="mt20">
                            <el-radio-group ref="sub9" v-model="form.sub9" :disabled="isAdmin">
                                <el-radio :label="0">D8090</el-radio><br>
                                <el-radio :label="1">D8080</el-radio><br>
                                <el-radio :label="2">D8060</el-radio><br>
                                <el-radio :label="3">A and B only</el-radio><el-image v-if="isAdmin&&form.sub9==3" class="rightPic" :src="right"></el-image>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub10!=3" :src="wrong"></el-image>
                            11) What is the purpose of Interceptive Orthodontic Treatment?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub10" class="mt20">
                            <el-radio-group ref="sub10" v-model="form.sub10" :disabled="isAdmin">
                                <el-radio :label="0">To help facilitate the eruption of permanent teeth.</el-radio><br>
                                <el-radio :label="1">To correct overcrowding of permanent teeth.</el-radio><br>
                                <el-radio :label="2">To correct malocclusion to reduce severe future complications.</el-radio><br>
                                <el-radio :label="3">Both A and C</el-radio><el-image v-if="isAdmin&&form.sub10==3" class="rightPic" :src="right"></el-image>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub11!=2" :src="wrong"></el-image>
                            12) Which dentition can be involved in an Interceptive Orthodontic Treatment?<span class="required">*</span></div>
                        <div class="score" > 2 points</div>
                        <el-form-item prop="sub11" class="mt20">
                            <el-radio-group ref="sub11" v-model="form.sub11" :disabled="isAdmin">
                                <el-radio :label="0">Primary</el-radio><br>
                                <el-radio :label="1">Transitional</el-radio><br>
                                <el-radio :label="2">Primary and Transitional</el-radio>
                                <el-image v-if="isAdmin&&form.sub11==2" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="3">Primary, Transitional and Adult</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub12!=0" :src="wrong"></el-image>
                            13) What is the purpose of Limited Orthodontic Treatment?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub12" class="mt20">
                            <el-radio-group ref="sub12" v-model="form.sub12" :disabled="isAdmin">
                                <el-radio :label="0"><div class="radioText">Orthodontic treatment directed at the only existing problem or one aspect of a<br v-if="smallScreen"> larger
                                    problem to defer or forego more<br v-if="!smallScreen"> comprehensive treatment.</div>
                                </el-radio><el-image v-if="isAdmin&&form.sub12==0" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="1" class="mt10"><div class="radioText">Orthodontic treatment utilized to limit the amount of time the patient has orthodontic
                                    <br v-if="smallScreen">appliances</div>
                                </el-radio><br>
                                <el-radio :label="2" :class="[smallScreen?'mt10':'']"><div class="radioText">Orthodontic treatment for patients who need limited appliances placed on the<br v-if="smallScreen"> dentition due to medical interferences.</div>
                                </el-radio><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub13!=2" :src="wrong"></el-image>
                            14) What tooth numbering system uses numbers 1-8 for each tooth in that
                            quadrant and vertical and horizontal lines to indicate which quadrant the
                            tooth is in?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub13" class="mt20">
                            <el-radio-group ref="sub13" v-model="form.sub13" :disabled="isAdmin">
                                <el-radio :label="0">International or F.D.I System</el-radio><br>
                                <el-radio :label="1">Universal or ADA System</el-radio><br>
                                <el-radio :label="2">Palmer System</el-radio><el-image v-if="isAdmin&&form.sub13==2" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="3">Traditional System</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub14!=3" :src="wrong"></el-image>
                            15) Which retention code should be used immediately following the
                            removal of active orthodontic appliances?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub14" class="mt20">
                            <el-radio-group ref="sub14" v-model="form.sub14" :disabled="isAdmin">
                                <el-radio :label="0">D8681: Removable orthodontic retainer adjustment</el-radio><br>
                                <el-radio :label="1">D8692: Replacement of lost or broken retainer</el-radio><br>
                                <el-radio :label="2">D8693: Re-cement or re-bond fixed retainer</el-radio><br>
                                <el-radio :label="3"><div class="radioText">D8680: Orthodontic retention (removal of appliances,
                                    construction and <br v-if="smallScreen">placement of retainers)</div>
                                </el-radio><el-image v-if="isAdmin&&form.sub14==3" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="4" :class="[smallScreen?'mt10':'']">D8694: Repair of fixed retainers, includes reattachment</el-radio><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub15!=1" :src="wrong"></el-image>
                            16) What information is needed in the remarks section on the initial
                            orthodontic claim for a comprehensive treatment?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub15" class="mt20">
                            <el-radio-group ref="sub15" v-model="form.sub15" :disabled="isAdmin">
                                <el-radio :label="0">Initial fee and down payment</el-radio><br>
                                <el-radio :label="1">Down payment, monthly payments and estimated treatment months</el-radio>
                                <el-image v-if="isAdmin&&form.sub15==1" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="2">Nothing, as long as all the boxes are complete on the claim form.</el-radio><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub16!=0" :src="wrong"></el-image>
                            17) True or False? The date the appliances were placed should ALWAYS be
                            entered in the appropriate box when submitting an initial, periodic or
                            retention claim.<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub16" class="mt20">
                            <el-radio-group ref="sub16"  v-model="form.sub16" :disabled="isAdmin">
                                <el-radio :label="0">True</el-radio><el-image v-if="isAdmin&&form.sub16==0" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="1">False</el-radio><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub17!=2" :src="wrong"></el-image>
                            18) If your patient's treatment length is estimated as 18-24 months, what
                            would be the best length of treatment that should be entered in box 42 of
                            the ADA claim form in order for the maximum benefit to be paid? *<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub17" class="mt20">
                            <el-radio-group ref="sub17" v-model="form.sub17" :disabled="isAdmin">
                                <el-radio :label="0">18</el-radio><br>
                                <el-radio :label="1">12</el-radio><br>
                                <el-radio :label="2">24</el-radio><el-image v-if="isAdmin&&form.sub17==2" class="rightPic" :src="right"></el-image><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub18!=1" :src="wrong"></el-image>
                            19) In order for the entire lifetime maximum for comprehensive treatment
                            to be paid, what length of treatment would need to be submitted?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub18" class="mt20">
                            <el-radio-group ref="sub18" v-model="form.sub18" :disabled="isAdmin">
                                <el-radio :label="0">12</el-radio><br>
                                <el-radio :label="1">24</el-radio><el-image v-if="isAdmin&&form.sub18==1" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="2">6</el-radio><br>
                                <el-radio :label="3">18</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub19!=3" :src="wrong"></el-image>
                            20) What type of claim needs to be sent to the insurance if the patient still
                            has a remaining orthodontic benefit, and treatment has been extended?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub19" class="mt20">
                            <el-radio-group ref="sub19" v-model="form.sub19" :disabled="isAdmin">
                                <el-radio :label="0">A secondary claim</el-radio><br>
                                <el-radio :label="1">A primary claim</el-radio><br>
                                <el-radio :label="2">An initial claim</el-radio><br>
                                <el-radio :label="3">A corrected claim of the initial claim</el-radio>
                                <el-image v-if="isAdmin&&form.sub19==3" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="4">Nothing, the insurance will just pay</el-radio><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub20!=4" :src="wrong"></el-image>
                            21) How are orthodontic benefits paid out?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub20" class="mt20">
                            <el-radio-group ref="sub20" v-model="form.sub20" :disabled="isAdmin">
                                <el-radio :label="0">All up front</el-radio><br>
                                <el-radio :label="1">Monthly</el-radio><br>
                                <el-radio :label="2">Quarterly</el-radio><br>
                                <el-radio :label="3">Annually</el-radio><br>
                                <el-radio :label="4">Monthly, Quarterly, or Annually.</el-radio>
                                <el-image v-if="isAdmin&&form.sub20==4" class="rightPic" :src="right"></el-image><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub21!=1" :src="wrong"></el-image>
                            22) True or False: Orthodontic treatment begins on 10/01/2016 and will
                            continue for 18 months. The insurance policy has a waiting period that
                            ends on 11/01/2016 and this policy covers treatment in progress.
                            Orthodontic benefits will NOT be paid in full?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub21" class="mt20">
                            <el-radio-group ref="sub21" v-model="form.sub21" :disabled="isAdmin">
                                <el-radio :label="0"><div class="radioText">False: Since the patient was seen for most of the benefit period, the insurance<br v-if="smallScreen">
                                    will cover the entire treatment period, as long as<br v-if="!smallScreen"> the policy is active.</div>
                                </el-radio><br>
                                <el-radio style="margin-top: 10px" :label="1"><div class="radioText">True: The insurance will pro-rate payments based on the treatment start date<br v-if="smallScreen">
                                    of 11/01/2016 instead of 10/01/2016.</div>
                                </el-radio><el-image v-if="isAdmin&&form.sub21==1" class="rightPic" :src="right"></el-image><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub22!=1" :src="wrong"></el-image>
                            23) When an orthodontic insurance policy terminates while a patient is still
                            in active treatment, what is it called when a new insurance picks up where
                            the previous insurance left off?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub22" class="mt20">
                            <el-radio-group ref="sub22" v-model="form.sub22" :disabled="isAdmin">
                                <el-radio :label="0">Non-duplication clause</el-radio><br>
                                <el-radio :label="1">Coverage for Treatment in Progress</el-radio>
                                <el-image v-if="isAdmin&&form.sub22==1" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="2">Dual Coverage</el-radio><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub23!=3" :src="wrong"></el-image>
                            24) Define UCR in relation to insurance?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub23" class="mt20">
                            <el-radio-group ref="sub23" v-model="form.sub23" :disabled="isAdmin">
                                <el-radio :label="0">Usual, Customary Rate</el-radio><br>
                                <el-radio :label="1">Under, Care, Reform</el-radio><br>
                                <el-radio :label="2">Up-code, Core, Response</el-radio><br>
                                <el-radio :label="3">Usual, Customary and Reasonable</el-radio>
                                <el-image v-if="isAdmin&&form.sub23==3" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="4">Usual, Custom, Remittance</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub24!=1" :src="wrong"></el-image>
                            25) If an insurance company states they will pay 50%, does that mean they
                            pay 50% of the total fee?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub24" class="mt20">
                            <el-radio-group ref="sub24" v-model="form.sub24" :disabled="isAdmin">
                                <el-radio :label="0">Yes, 50% of the total fee</el-radio><br>
                                <el-radio :label="1">50% of the max allowable fee OR the life-time maximum benefit-whichever is less.</el-radio>
                                <el-image v-if="isAdmin&&form.sub24==1" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="2">No, 50% of the life-time maximum</el-radio><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub25!=0" :src="wrong"></el-image>
                            26) If you receive notification that an insurance policy has terminated in
                            the middle of a patient’s orthodontic treatment, what procedure should
                            be followed?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub25" class="mt20">
                            <el-radio-group ref="sub25" v-model="form.sub25" :disabled="isAdmin">
                                <el-radio :label="0"><div class="radioText">First, contact responsible party to verify. Then, once cancellation is verified, financial
                                    <br v-if="smallScreen">coordinator contacts responsible <br v-if="!smallScreen">party to pay insurance balance or change financial
                                    <br v-if="smallScreen">contract. Finally, remove all remaining insurance claims/forms.</div>
                                </el-radio><el-image v-if="isAdmin&&form.sub25==0" class="rightPic" :src="right"></el-image><br>
                                <el-radio :class="[smallScreen?'mt30':'mt10']" :label="1"><div class="radioText">First, remove all insurance claims/forms from patient leger. Second, send responsible
                                    <br v-if="smallScreen">party a statement showing final balance.</div>
                                </el-radio><br>
                                    <el-radio :label="2" :class="[smallScreen?'mt20':'']"><div class="radioText">First, have the responsible party sign a new contract, redefining new payment
                                        <br v-if="smallScreen">arrangements. Second, verify with the<br v-if="!smallScreen"> responsible party that insurance has in<br v-if="smallScreen"> fact terminated.</div>
                                </el-radio><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub26!=2" :src="wrong"></el-image>
                            27) Which series of CDT codes does orthodontics fall under?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub26" class="mt20">
                            <el-radio-group ref="sub26" v-model="form.sub26" :disabled="isAdmin">
                                <el-radio :label="0">D4000-D4999</el-radio><br>
                                <el-radio :label="1">D6000-D6499</el-radio><br>
                                <el-radio :label="2">D8000-D8999</el-radio><el-image v-if="isAdmin&&form.sub26==2" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="3">D0100-D0999</el-radio><br>
                                <el-radio :label="4">D9000-D9999</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub27!=1" :src="wrong"></el-image>
                            28) When sending a claim to the patient’s secondary insurance, how long
                            after the primary claim is sent should you send the secondary claim?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub27" class="mt20">
                            <el-radio-group ref="sub27" v-model="form.sub27" :disabled="isAdmin">
                                <el-radio :label="0">The same time the primary claim is sent</el-radio><br>
                                <el-radio :label="1">After the primary has paid the initial payment</el-radio>
                                <el-image v-if="isAdmin&&form.sub27==1" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="2">After the primary has paid their entire lifetime maximum</el-radio><br>
                                <el-radio :label="3">Before the primary claim is sent</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub28!=0" :src="wrong"></el-image>
                            29) If an orthodontic insurance policy does not cover treatment in
                            progress and it is picked up in the middle of a patient’s orthodontic
                            coverage after their previous insurance terminated, what information will
                            be needed on the initial claim form?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub28" class="mt20">
                            <el-radio-group ref="sub28" v-model="form.sub28" :disabled="isAdmin">
                                <el-radio :label="0"><div class="radioText">An insurance claim will not be sent, since the insurance will not cover treatment
                                    <br v-if="smallScreen">in progress.</div></el-radio><el-image v-if="isAdmin&&form.sub28==0" class="rightPic" :src="right"></el-image><br>
                                <el-radio :class="[smallScreen?'mt10':'']" :label="1"><div class="radioText">In remarks section, state: “Please process according to policy effective date.”
                                    <br v-if="smallScreen">Provide the lifetime max of previous<br v-if="!smallScreen"> insurance, their deductible and the total<br v-if="smallScreen"> payments they made.</div>
                                </el-radio><br>
                                <el-radio :class="[smallScreen?'mt30':'mt10']" :label="2">Previous insurance EOBs</el-radio><br>
                                <el-radio :label="3">Copy of the patient’s ledger</el-radio><br>
                                <el-radio :label="4">Panoramic radiograph, cephalometric radiograph and treatment plan.
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub29!=4" :src="wrong"></el-image>
                            30) When obtaining an orthodontic benefit breakdown for a new
                            orthodontic policy, what important information should you obtain
                            regarding the amount of a total benefit that will be paid out?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub29" class="mt20">
                            <el-radio-group ref="sub29" v-model="form.sub29" :disabled="isAdmin">
                                <el-radio :label="0">What is the life-time maximum and how much of their remaining maximum remains?
                                </el-radio><br>
                                <el-radio :label="1">How often claims should be submitted</el-radio><br>
                                <el-radio :label="2">Is treatment in progress covered?</el-radio><br>
                                <el-radio :label="3">Is there is a waiting period for orthodontic benefits?</el-radio><br>
                                <el-radio :label="4">All of the above</el-radio><el-image v-if="isAdmin&&form.sub29==4" class="rightPic" :src="right"></el-image>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub30!=3" :src="wrong"></el-image>
                            31) When obtaining an orthodontic benefit breakdown for a patient who
                            has picked up orthodontic coverage in the middle of treatment, what
                            important information should you obtain before ensuring the patient’s
                            orthodontic policy will reimburse your practice?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub30" class="mt20">
                            <el-radio-group ref="sub30" v-model="form.sub30" :disabled="isAdmin">
                                <el-radio :label="0">If there are age limitations for orthodontic benefits</el-radio><br>
                                <el-radio :label="1">How often claims should be submitted</el-radio><br>
                                <el-radio :label="2">If claims are processed automatically or quarterly</el-radio><br>
                                <el-radio :label="3">If treatment in progress is covered</el-radio>
                                <el-image v-if="isAdmin&&form.sub30==3" class="rightPic" :src="right"></el-image>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub31!=1" :src="wrong"></el-image>
                            32) When obtaining an orthodontic benefit breakdown for a 45 year old,
                            what important information should you obtain before ensuring the patient
                            has orthodontic coverage?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub31" class="mt20">
                            <el-radio-group ref="sub31"  v-model="form.sub31" :disabled="isAdmin">
                                <el-radio :label="0">If treatment in progress is covered</el-radio><br>
                                <el-radio :label="1">If there are age limitations for orthodontic benefits</el-radio>
                                <el-image v-if="isAdmin&&form.sub31==1" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="2">How often claims should be submitted</el-radio><br>
                                <el-radio :label="3">If claims are processed automatically or quarterly</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub32!=2" :src="wrong"></el-image>
                            33) Define HMO, and explain what the member is obligated to do when
                            they have an HMO plan.<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub32" class="mt20">
                            <el-radio-group ref="sub32" v-model="form.sub32" :disabled="isAdmin">
                                <el-radio :label="0"><div class="radioText">Health Monitored Organization: The member is required to file claims for<br v-if="smallScreen">
                                    services rendered.</div></el-radio><br>
                                <el-radio :label="1" :class="[smallScreen?'mt10':'']"><div class="radioText">Healthcare Medical Organization: The member is required to maintain their<br v-if="smallScreen">
                                    dental record via a remote server.</div>
                                </el-radio><br>
                                <el-radio :label="2" :class="[smallScreen?'mt10':'']"><div class="radioText">Health Maintenance Organization, the member is required to see only a provider<br v-if="smallScreen">
                                    within the health maintenance organization</div></el-radio>
                                <el-image v-if="isAdmin&&form.sub32==2" class="rightPic" :src="right"></el-image><br>
                            </el-radio-group>
                        </el-form-item>
                    </div> <div class="box">
                    <div class="subjectTest"><el-image v-if="isAdmin&&form.sub33!=1" :src="wrong"></el-image>
                        34) Define PPO<span class="required">*</span></div>
                    <div class="score" >2 points</div>
                    <el-form-item prop="sub33" class="mt20">
                        <el-radio-group ref="sub33" v-model="form.sub33" :disabled="isAdmin">
                            <el-radio :label="0">Preferred Policy Organization</el-radio><br>
                            <el-radio :label="1">Preferred Provider Organization</el-radio>
                            <el-image v-if="isAdmin&&form.sub33==1" class="rightPic" :src="right"></el-image><br>
                            <el-radio :label="2">Pre-determined Provider Option</el-radio><br>
                            <el-radio :label="3">Pre-determined Policy Organization</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub34!=0" :src="wrong"></el-image>
                            35) If your patient receives dental treatment in your practice and has an
                            HMO plan, and you are not part of the HMO, will your practice still be
                            reimbursed for services rendered?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub34" class="mt20">
                            <el-radio-group ref="sub34" v-model="form.sub34" :disabled="isAdmin">
                                <el-radio :label="0"><div class="radioText">No. Since the member is required to see only a provider within the HMO, services<br v-if="smallScreen">
                                    rendered will not be reimbursed.</div>
                                </el-radio><el-image v-if="isAdmin&&form.sub34==0" class="rightPic" :src="right"></el-image><br>
                                <el-radio :class="[smallScreen?'mt10':'']" :label="1">Yes. An HMO plan offers the flexibility to visit providers outside of their network.
                                </el-radio><br>
                                <el-radio :label="2"><div class="radioText">Yes, but the services rendered will be greatly discounted, since HMO plans offer <br v-if="smallScreen">
                                    very low coinsurances, deductibles and premiums.</div>
                                </el-radio><br>
                                <el-radio :label="3" :class="[smallScreen?'mt10':'']" >No. There is no way to verify that the patient has maintained their dental record.
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub35!=4" :src="wrong"></el-image>
                            36) What codes should be used to indicate a fee upgrade? For example: a
                            comprehensive orthodontic treatment using Invisalign?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub35" class="mt20">
                            <el-radio-group ref="sub35" v-model="form.sub35" :disabled="isAdmin">
                                <el-radio :label="0"><div class="radioText">None, D8090 is the only code needed and the fee should be the same for every<br v-if="smallScreen">
                                    adult comprehensive treatment</div>
                                </el-radio><br>
                                <el-radio :label="1" :class="[smallScreen?'mt10':'']">Two separate comprehensive codes, D8090 and D8080.
                                </el-radio><br>
                                <el-radio :label="2"><div class="radioText">D8090 and D9999 (Miscellaneous adjunctive services) and a statement in the<br v-if="smallScreen">
                                    remarks section for the D9999 code stating that it is for Invisalign</div></el-radio><br>
                                <el-radio :label="3" :class="[smallScreen?'mt10':'']">D8090 and D8690 (orthodontic treatment)
                                </el-radio><br>
                                <el-radio :label="4"><div class="radioText">D8080/D8090 and D8999 (Miscellaneous orthodontic services) and a statement<br v-if="smallScreen">
                                    in the remarks section for the <br v-if="!smallScreen">D8999 code stating that it is for Invisalign.</div>
                                </el-radio><el-image v-if="isAdmin&&form.sub35==4" class="rightPic" :src="right"></el-image>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest">Please use the following EOB to answer question 37-40</div>
                        <el-image style="margin-top: 20px" :src="pic_daughter"></el-image>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub36!=4" :src="wrong"></el-image>
                            37) Which payment of this patient’s orthodontic treatment can you
                            assume this is?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub36" class="mt20">
                            <el-radio-group ref="sub36" v-model="form.sub36" :disabled="isAdmin">
                                <el-radio :label="0">Monthly</el-radio><br>
                                <el-radio :label="1">Quarterly</el-radio><br>
                                <el-radio :label="2">Final</el-radio><br>
                                <el-radio :label="3">Initial</el-radio><br>
                                <el-radio :label="4">b and c</el-radio><el-image v-if="isAdmin&&form.sub36==4" class="rightPic" :src="right"></el-image>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub37!=1" :src="wrong"></el-image>
                            38) Did Aetna pay for date of service 07/28/16?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub37" class="mt20">
                            <el-radio-group ref="sub37" v-model="form.sub37" :disabled="isAdmin">
                                <el-radio :label="0">Yes</el-radio><br>
                                <el-radio :label="1">No</el-radio><el-image v-if="isAdmin&&form.sub37==1" class="rightPic" :src="right"></el-image>
                            </el-radio-group>
                        </el-form-item>
                    </div> <div class="box">
                    <div class="subjectTest"><el-image v-if="isAdmin&&form.sub38!=0" :src="wrong"></el-image>
                        39) Has the lifetime maximum been met according to the EOB?<span class="required">*</span></div>
                    <div class="score" >2 points</div>
                    <el-form-item prop="sub38" class="mt20">
                        <el-radio-group ref="sub38" v-model="form.sub38" :disabled="isAdmin">
                            <el-radio :label="0">Yes</el-radio><el-image v-if="isAdmin&&form.sub38==0" class="rightPic" :src="right"></el-image><br>
                            <el-radio :label="1">No</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub39!=2" :src="wrong"></el-image>
                            40) What would you do after posting this payment for the patient’s
                            orthodontic treatment?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub39" class="mt20">
                            <el-radio-group ref="sub39" v-model="form.sub39" :disabled="isAdmin">
                                <el-radio :label="0">Move any remaining insurance account balance to patient account.
                                </el-radio><br>
                                <el-radio :label="1">Nothing, there are still more payments that will be automatically sent to the practice.
                                </el-radio><br>
                                <el-radio :label="2"><div class="radioText">Investigate the history of Aetna’s orthodontic payments to ensure that the lifetime<br v-if="smallScreen">
                                    max has been paid. If not, find out<br v-if="!smallScreen"> if there are missing payments.</div></el-radio>
                                <el-image v-if="isAdmin&&form.sub39==2" class="rightPic" :src="right"></el-image><br>
                                <el-radio style="margin-top: 10px" :label="3">Send next quarter’s orthodontic claim for confirmation of continued treatment.</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest">Please use the following EOB for questions 41-43</div>
                        <el-image style="margin-top: 20px" :src="pic_son"></el-image>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub40!=1" :src="wrong"></el-image>
                            41) According to this EOB, what is the PPO discount?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub40" class="mt20">
                            <el-radio-group ref="sub40" v-model="form.sub40" :disabled="isAdmin">
                                <el-radio :label="0">$1206.00</el-radio><br>
                                <el-radio :label="1">$257.00</el-radio><el-image v-if="isAdmin&&form.sub40==1" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="2">$474.50</el-radio><br>
                                <el-radio :label="3">$949.00</el-radio><br>
                                <el-radio :label="4">There is no PPO discount.</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div> <div class="box">
                    <div class="subjectTest"><el-image v-if="isAdmin&&form.sub41!=3" :src="wrong"></el-image>
                        42) Which payment of this patient’s orthodontic treatment can you
                        assume that this is?<span class="required">*</span></div>
                    <div class="score" >2 points</div>
                    <el-form-item prop="sub41" class="mt20">
                        <el-radio-group ref="sub41"  v-model="form.sub41" :disabled="isAdmin">
                            <el-radio :label="0">Monthly</el-radio><br>
                            <el-radio :label="1">Quarterly</el-radio><br>
                            <el-radio :label="2">Final</el-radio><br>
                            <el-radio :label="3">Initial</el-radio><el-image v-if="isAdmin&&form.sub41==3" class="rightPic" :src="right"></el-image>
                        </el-radio-group>
                    </el-form-item>
                </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub42!=2" :src="wrong"></el-image>
                            43) After this payment, what amount will be used to calculate the
                            remaining payments?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub42" class="mt20">
                            <el-radio-group ref="sub42" v-model="form.sub42" :disabled="isAdmin">
                                <el-radio :label="0">$3796.00</el-radio><br>
                                <el-radio :label="1">$2847.00</el-radio><br>
                                <el-radio :label="2">$3321.50</el-radio><el-image v-if="isAdmin&&form.sub42==2" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="3">$4053.00</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest">Please use the following EOB to answer questions 44-49.</div>
                        <el-image style="margin-top: 20px" :src="pic_heath"></el-image>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub43!=2" :src="wrong"></el-image>
                            44) According to this EOB, what is the available lifetime maximum?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub43" class="mt20">
                            <el-radio-group ref="sub43" v-model="form.sub43" :disabled="isAdmin">
                                <el-radio :label="0">$211.50</el-radio><br>
                                <el-radio :label="1">$50.00</el-radio><br>
                                <el-radio :label="2">$1000.00</el-radio><el-image v-if="isAdmin&&form.sub43==2" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="3">3 months</el-radio><br>
                                <el-radio :label="4">Quarterly</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub44!=4" :src="wrong"></el-image>
                            45) According to this EOB, what is the down payment?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub44" class="mt20">
                            <el-radio-group ref="sub44" v-model="form.sub44" :disabled="isAdmin">
                                <el-radio :label="0">$1000.00</el-radio><br>
                                <el-radio :label="1">$211.50</el-radio><br>
                                <el-radio :label="2">Quarterly</el-radio><br>
                                <el-radio :label="3">$50.00</el-radio><br>
                                <el-radio :label="4">$499.00</el-radio><el-image v-if="isAdmin&&form.sub44==4" class="rightPic" :src="right"></el-image>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub45!=1" :src="wrong"></el-image>
                            46) According to this EOB, what are the payments, and how often are they
                            made?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub45" class="mt20">
                            <el-radio-group ref="sub45" v-model="form.sub45" :disabled="isAdmin">
                                <el-radio :label="0">$50.00 every year</el-radio><br>
                                <el-radio :label="1">$211.50 every 3 months</el-radio><el-image v-if="isAdmin&&form.sub45==1" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="2">Initial payment of $499.00</el-radio><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub46!=2" :src="wrong"></el-image>
                            47) Does this plan have a deductible? How much?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub46" class="mt20">
                            <el-radio-group ref="sub46" v-model="form.sub46" :disabled="isAdmin">
                                <el-radio :label="0">No, there is no deductible</el-radio><br>
                                <el-radio :label="1">Yes, $1000.00</el-radio><br>
                                <el-radio :label="2">Yes, $50.00</el-radio><el-image v-if="isAdmin&&form.sub46==2" class="rightPic" :src="right"></el-image><br>
                                <el-radio :label="3">Yes, $211.50</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub47!=1" :src="wrong"></el-image>
                            48) Orthodontic Payments are paid monthly with a new claim submitted
                            each month for all orthodontic treatment.<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub47" class="mt20">
                            <el-radio-group ref="sub47" v-model="form.sub47" :disabled="isAdmin">
                                <el-radio :label="0">True</el-radio><br>
                                <el-radio :label="1">False</el-radio><el-image v-if="isAdmin&&form.sub47==1" class="rightPic" :src="right"></el-image><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub48!=1" :src="wrong"></el-image>
                            49) Orthodontic payments are being made on a monthly frequency per
                            the EOB?<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub48" class="mt20">
                            <el-radio-group ref="sub48" v-model="form.sub48" :disabled="isAdmin">
                                <el-radio :label="0">True</el-radio><br>
                                <el-radio :label="1">False</el-radio><el-image v-if="isAdmin&&form.sub48==1" class="rightPic" :src="right"></el-image><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="subjectTest"><el-image v-if="isAdmin&&form.sub49!=1" :src="wrong"></el-image>
                            50) General procedures can be deducted from orthodontic lifetime
                            maximums.<span class="required">*</span></div>
                        <div class="score" >2 points</div>
                        <el-form-item prop="sub49" class="mt20">
                            <el-radio-group ref="sub49" v-model="form.sub49" :disabled="isAdmin">
                                <el-radio :label="0">False</el-radio><br>
                                <el-radio :label="1">True</el-radio><el-image v-if="isAdmin&&form.sub49==1" class="rightPic" :src="right"></el-image><br>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="btnLayout">
                        <el-button class="yellowBtn" @click="submitPrepare" v-if="!isAdmin">Submit</el-button>
                        <el-button class="grayBtn" @click="cancel">Cancel</el-button>
                        <span style="margin-left:10px" v-if="isAdmin">Exam Completed {{ forMateTime(finishDate,true) }}</span>
                    </div>
                </el-form>
            </div>
            <div class="box" v-if="showResult&&hasFinished">
                <h1 class="serviceTestTitle">eAssist Orthodontic Billing Assessment Test</h1>
                <!--
                <span>Of the parts of this exam that can be automatically graded you have recieved </span>
                <span>{{correctNum}}</span>/{{totalNum}} ({{correctPercent}})-->
                <span>Thank you for completing this knowledge assessment!</span><br/>
                <span>Please allow up to three business days while we review your application.</span>
                <br>
                <el-button class="yellowBtn" style="margin-top: 10px;" @click="goPre">Back</el-button>
            </div>
            </section>
        </div>
        <el-dialog title="Confirm" :visible.sync="exitVisible">
            <div>Are you sure you want to cancel the test?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="goBack">Yes</el-button>
                <el-button class="grayBtn" @click="exitVisible=false">No</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Confirm" :visible.sync="confirmVisible" width="50%">
            <div style="line-height: 25px;padding: 0 10px;word-wrap:break-word">Caution:this portion of our skills assessment test you are about to view cannot be saved for later. You will
            be scored with no option to return later if you proceed. Do you want to continue?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="submit">Yes</el-button>
                <el-button class="grayBtn" @click="confirmVisible=false">No</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="Assessment Complete"
            :visible.sync="completionDialogVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="50%">
            <div style="text-align: center">
                <p>Thank you for completing this knowledge assessment.</p>
                <p>Please allow up to three business days while we review your application.</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="yellowBtn" @click="handleCompletionConfirm">OK</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import pic_daughter from "../../assets/pic/daughter.jpg"
    import pic_son from "../../assets/pic/son.jpg"
    import pic_heath from "../../assets/pic/healthcare.jpg"
    import wrong from "../../assets/pic/wrong.png"
    import right from "../../assets/pic/right.png"
    import ApplyHeader from "../../components/ApplyHeader";
    import Side from '../../components/Aside.vue'
    import { chat2Ascii } from "../../../static/js/util"
    export default {
        name: "Ohodontic",
        components:{
            ApplyHeader,
            Side
        },
        data(){
            return{
                finishDate:'',
                loading:false,
                smallScreen:false,
                confirmVisible:false,
                exitVisible:false,
                correctNum:0,
                totalNum:50,
                passPercent:'0%',
                isAdmin:false,
                showResult:false,
                hasFinished:false,
                pic_daughter:pic_daughter,
                pic_son:pic_son,
                pic_heath:pic_heath,
                wrong:wrong,
                right:right,
                completionDialogVisible: false, 
                form:{
                    software:''
                },
                /**表单验证规则，所有选项都不允许为空**/
                rules:{
                    software:[ { required: true, message: 'Required', trigger: 'blur' }],
                    sub0: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub1: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub2: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub3: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub4: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub5: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub6: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub7: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub8: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub9: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub10: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub11: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub12: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub13: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub14: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub15: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub16: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub17: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],sub18: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],sub19: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],sub20: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub21: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],sub22: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub23: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub24: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],sub25: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],sub26: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub27: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub28: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub29: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub30: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub31: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub32: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub33: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub34: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub35: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub36: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub37: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub38: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub39: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub40: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub41: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub42: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub43: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],sub44: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],sub45: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub46: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub47: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub48: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                    sub49: [
                        { required: true, message: 'Required', trigger: 'blur' },
                    ],
                }
            }
        },
        computed:{
            /**根据用户自己选择算出正确率**/
            correctPercent(){
                var per = (this.correctNum*100/this.totalNum).toFixed(2)+'%'
                return per
            },
            getHeight(){
                return document.documentElement.clientHeight
            }
        },
        methods:{
            /**和正确答案对比算出得分**/
            calScore(){
                var score=0
                this.correctNum=0
                if(this.form.sub0==2){score+=2;this.correctNum++}
                if(this.form.sub1==1){score+=2;this.correctNum++}
                if(this.form.sub2==0){score+=2;this.correctNum++}
                if(this.form.sub3==3){score+=2;this.correctNum++}
                if(this.form.sub4==1){score+=2;this.correctNum++}
                if(this.form.sub5==1){score+=2;this.correctNum++}
                if(this.form.sub6==1){score+=2;this.correctNum++}
                if(this.form.sub7==1){score+=2;this.correctNum++}
                if(this.form.sub8==0){score+=2;this.correctNum++}
                if(this.form.sub9==3){score+=2;this.correctNum++}
                if(this.form.sub10==3){score+=2;this.correctNum++}
                if(this.form.sub11==2){score+=2;this.correctNum++}
                if(this.form.sub12==0){score+=2;this.correctNum++}
                if(this.form.sub13==2){score+=2;this.correctNum++}
                if(this.form.sub14==3){score+=2;this.correctNum++}
                if(this.form.sub15==1){score+=2;this.correctNum++}
                if(this.form.sub16==0){score+=2;this.correctNum++}
                if(this.form.sub17==2){score+=2;this.correctNum++}
                if(this.form.sub18==1){score+=2;this.correctNum++}
                if(this.form.sub19==3){score+=2;this.correctNum++}
                if(this.form.sub20==4){score+=2;this.correctNum++}
                if(this.form.sub21==1){score+=2;this.correctNum++}
                if(this.form.sub22==1){score+=2;this.correctNum++}
                if(this.form.sub23==3){score+=2;this.correctNum++}
                if(this.form.sub24==1){score+=2;this.correctNum++}
                if(this.form.sub25==0){score+=2;this.correctNum++}
                if(this.form.sub26==2){score+=2;this.correctNum++}
                if(this.form.sub27==1){score+=2;this.correctNum++}
                if(this.form.sub28==0){score+=2;this.correctNum++}
                if(this.form.sub29==4){score+=2;this.correctNum++}
                if(this.form.sub30==3){score+=2;this.correctNum++}
                if(this.form.sub31==1){score+=2;this.correctNum++}
                if(this.form.sub32==2){score+=2;this.correctNum++}
                if(this.form.sub33==1){score+=2;this.correctNum++}
                if(this.form.sub34==0){score+=2;this.correctNum++}
                if(this.form.sub35==4){score+=2;this.correctNum++}
                if(this.form.sub36==4){score+=2;this.correctNum++}
                if(this.form.sub37==1){score+=2;this.correctNum++}
                if(this.form.sub38==0){score+=2;this.correctNum++}
                if(this.form.sub39==2){score+=2;this.correctNum++}
                if(this.form.sub40==1){score+=2;this.correctNum++}
                if(this.form.sub41==3){score+=2;this.correctNum++}
                if(this.form.sub42==2){score+=2;this.correctNum++}
                if(this.form.sub43==2){score+=2;this.correctNum++}
                if(this.form.sub44==4){score+=2;this.correctNum++}
                if(this.form.sub45==1){score+=2;this.correctNum++}
                if(this.form.sub46==2){score+=2;this.correctNum++}
                if(this.form.sub47==1){score+=2;this.correctNum++}
                if(this.form.sub48==1){score+=2;this.correctNum++}
                if(this.form.sub49==1){score+=2;this.correctNum++}
                return score
            },
            cancel(){
                this.exitVisible=true
            },
            submit(){
                this.confirmVisible = false
                var score=0
                var list=[]
                // console.log('提交',this.form)
                for(var i in this.form){
                    list.push(this.form[i])
                }
                score = this.calScore()
                var storeService = this.$store.state.serviceInfo
                //var positionInfo = this.$store.state.positionInfo
                var params={}
                params.serviceId =storeService.serviceId
                params.versionId = storeService.serviceVersion
                params.score = score
                params.possible = 100
                params.positionId = 0
                params.status = score > storeService.servicePassScore ? 1: 0
                params.detail = JSON.stringify(list)
                params.applicantEmail=localStorage.getItem('email')
                this.loading=true
                this.$axios.post(this.$URL.serviceTestUrl,params).then(res=>{
                    this.loading=false
                    if(res.code==0){
                        this.completionDialogVisible = true
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            handleCompletionConfirm() {
                this.completionDialogVisible = false
                this.goBack()
            },
            /**提交之前先判断是否有未填选项,增加用户体验**/
            submitPrepare(){
                // console.log('submit',this.form)
                this.$refs['form'].clearValidate()
                this.$nextTick(() => {
                        this.$refs['form'].validate((valid,object) => {
                            if (valid) {
                                // console.log('submit111',this.form)
                                this.confirmVisible = true
                            }else {
                                var obj = Object.keys(object)[0]
                                let dom = this.$refs[obj]
                                dom.$el.scrollIntoView({
                                    //滚动到指定节点
                                    block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                                    behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                                })
                                // console.log('error submit!!');
                                return false;
                            }
                        })
                })
            },
            getUserAnswerData(id,email){
                // console.log('id',id);
                // console.log('email',email);
                this.loading=true
                this.$axios.get(this.$URL.gradeUrl,{params:{serviceId:id,email:email}}).then(res=>{
                    this.loading=false
                    if(res&&res.code==0){
                        // console.log('用户答题数据',res)
                        this.hasFinished=true
                        /**取到用户答题数据重构form显示答题详情**/
                        if(res.data&&res.data.detail!=null){
                            this.finishDate = res.data.finishDate||''
                            var list = res.data.detail
                            this.form.software=list[0]
                            for(var i=1;i<list.length;i++){
                                this.$set(this.form,('sub'+(i-1)),Number(list[i]))
                            }
                            this.calScore()
                        }
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            getData(){
                if(this.$route.query&&this.$route.query.model=='review'&&this.$route.query.verify){
                    var serviceId = this.$route.query.serviceId
                    var verify = this.$route.query.verify
                    var email = this.$route.query.email
                    var verifyCode = chat2Ascii(email)
                    if(verifyCode != verify){
                        this.$router.push('/login')
                        return
                    }
                    this.getUserAnswerData(serviceId,email)
                    this.isAdmin=true
                    return
                }
                var storeService = this.$store.state.serviceInfo
                 //when no serviceid info, go back to service list
                // console.log('get serviceId:' + storeService.serviceId)
                if(storeService.serviceId == undefined){
                    this.$router.push({path:'/service'})
                    return
                }
                var user = localStorage.getItem('email')
                this.getUserAnswerData(storeService.serviceId,user)
                var status = storeService.status
                if(status==2||status==3){
                    this.showResult=true
                }
                this.passPercent = (((storeService.servicePassScore||0)/100).toFixed(2)*100)+'%'
            },
            goPre(){
                this.$router.go(-1)
            },
            goBack(){
                this.$router.push({path:'/service'})
            }
        },
        mounted() {
            //由于elementui radio控件的坑无法正常换行只有根据屏幕分辨率加入换行字符进行换行
             var clientW = document.documentElement.clientWidth
             if(clientW<1220){
                 this.smallScreen=true
             }
        },
        created() {
            this.getData()
        },
        watch:{
            '$route'(to,from){
                // console.log(from.path)
                if(to.path==='/ohodonticTest'){
                    this.getData()
                }
            }
        }
    }
</script>

<style scoped>
    .rightPic{
        width: 20px;
        position: absolute;
        margin-top: 10px;
        right: 20px
    }
    .el-radio{
        width:200px;
        height:43px;
        line-height:20px!important;
    }
    .box>>>.el-radio__label{
        vertical-align: middle!important;
    }
    .radioText{
        display: inline-block;
    }
    .btnLayout{
        margin:10px 0 20px 15px
    }
    @media screen and (max-width: 1440px) {
        .btnLayout{
            margin:10px 0 20px 5px
        }
    }
    @media screen and (max-width: 1200px) {
        .btnLayout{
            margin:10px 0 20px 0px
        }
    }
</style>
